<template lang="pug">
nav.d-flex.flex-wrap.justify-end.main-header-nav-menu
  v-btn.text-none.text-body-1.text-uppercase.font-weight-bold(
    v-for="(route, i) in menu",
    :key="i",
    :to="route.path",
    color="white",
    active-class="secondary--text",
    text
  ) {{ route.name }}
</template>

<script>
export default {
  props: {
    menu: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style>
.main-header-nav-menu {
  gap: 24px;
}
</style>
